import "./Tumbler.scss"

import { useState } from "react"

import { classWithModifiers } from "@/utils/common"

interface TumblerProps {
  leftText?: string
  rightText?: string
  checked?: boolean
  defaultChecked?: boolean

  readonly?: boolean

  type?: string
  onChange?: (checked: boolean) => void
}

function Tumbler(props: TumblerProps) {
  const isControlled = props.checked != null
  const [internalChecked, setInternalChecked] = useState(props.defaultChecked ?? false)

  const checked = isControlled ? props.checked! : internalChecked

  function updateChecked(value: boolean) {
    if (props.readonly) return

    if (!isControlled) {
      setInternalChecked(value)
    }
    props.onChange?.(value)
  }
  return (
    <div className={classWithModifiers("tumbler", props.type)}>
      <div className={classWithModifiers("tumbler-shift", checked && "checked")} onClick={() => updateChecked(!checked)}>
        <div className="tumbler-shift__circle" />
      </div>
    </div>
  )
}

export default Tumbler
